import {HiOutlineMail} from "react-icons/hi";
import {FaWhatsapp} from "react-icons/fa";

const data = [
    {id: 1, icon: <HiOutlineMail/>, link: "mailto:chelizt@gmail.com", type: "email"},
    {id: 2, icon: <FaWhatsapp/>, link: "https://wa.me/+31627218044", type: "whatsapp"},
];

export default data;
